<template>
    <div class="nav-menu">
        <button class="nav-menu__link" @click="toggleMenu()">
            <span class="hamburger"></span>
            <span class="h:hide-mobile">{{ trans('menu.menu') }}</span>
        </button>

        <div class="nav-menu__overlay">

            <overlay :active="showMenu">
                <div class="container">
                    <div class="nav-overlay">
                        <div class="nav-overlay__header">
                            <button class="nav-overlay__close" @click="toggleMenu()">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 751 751">
                                    <path d="M400,24.5C192.62,24.5,24.5,192.62,24.5,400S192.62,775.5,400,775.5,775.5,607.38,775.5,400,607.38,24.5,400,24.5ZM400,740C212.22,740,60,587.78,60,400S212.22,60,400,60,740,212.22,740,400,587.78,740,400,740Z" transform="translate(-24.5 -24.5)"/><rect x="120" y="375" width="560" height="50" transform="translate(375.5 941.19) rotate(-135)"/><rect x="120" y="375" width="560" height="50" transform="translate(-190.19 375.5) rotate(-45)"/>
                                </svg>
                                <span>{{ trans('menu.close') }}</span>
                            </button>
                            <div class="nav-overlay__logout">
                                <logout-link>
                                    {{ trans('menu.logout') }}
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 867.89 751">
                                        <polygon points="867.89 375.5 663.8 234.5 663.8 516.5 867.89 375.5"/><rect x="296" y="360" width="400" height="80" transform="translate(967.5 775.5) rotate(180)"/><path d="M669,608c-62.19,80.3-159.53,132-269,132C212.22,740,60,587.78,60,400S212.22,60,400,60c109.88,0,207.56,52.13,269.72,133h43.61C646.12,91.47,530.88,24.5,400,24.5,192.62,24.5,24.5,192.62,24.5,400S192.62,775.5,400,775.5C530.45,775.5,645.36,709,712.67,608Z" transform="translate(-24.5 -24.5)"/>
                                    </svg>
                                </logout-link>
                            </div>
                        </div>

                        <div class="nav-overlay__body">
                            <nav-items
                                :policies="policies">
                            </nav-items>
                        </div>
                    </div>
                </div>
            </overlay>

        </div>
    </div>
</template>

<script>
import {onKeyPress} from '../../util/onKeyPress';

export default {
    props: [
        'policies',
    ],

    data() {
        return {
            showMenu: false,
        };
    },

    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        closeMenu() {
            this.showMenu = false;
        }
    },

    mounted() {
        onKeyPress('esc', this.closeMenu);
    }
}
</script>
